<template>
  <div class="classic-book-website">
    <!-- 第一区域：顶部公司信息 -->
    <!-- 网站顶部的component共用模块引入 -->
    <atop ref="atop"></atop>

    <!-- 第二区域：全站搜索区 -->
    <!-- 网站搜索区的component共用模块引入 -->
    <atopsearch ref="atopsearch"></atopsearch>

    <!-- 第三区域：边疆文献展示区 -->
    <section class="main-section">
      <div class="container">  
        <!-- 边疆文献分类标题 -->
        <div class="category-header">
          <div class="category-header-left">
            <div class="category-title" style="cursor: pointer;" @click="goBackPage">&lt;上页</div>
            <div class="category-title">&nbsp;-&nbsp;{{theClassName}}</div>
          </div>
          <div class="category-count">数量：{{ totalBooks }}</div>
        </div>

        <!-- 年份标签区 -->
        <!-- 20260323 modify，所有的有二级分类的都展示二级分类 -->
        <!-- <div class="year-tags-section" v-if="theClassName=='期刊报纸（有年份差别）'"> -->
        <div class="year-tags-section" v-if="displayedYears.length > 1">
          <div class="year-tags-title">
            <i class="el-icon-date"></i>
            {{theClassLabel}}
          </div>
          <div class="year-tags">
            <div 
              v-for="year in displayedYears" 
              :key="year"
              class="year-tag"
              :class="{ 
                'active': selectedYear === year,
                'more-tag': year === 'more...'
              }"
              @click="handleYearClick(year)"
            >
              {{ year === 'more...' ? '更多...' : year }}
            </div>
          </div>
        </div>

        <!-- 书籍展示区 -->
        <div class="books-container">
          <!-- 书籍网格 -->
          <div class="books-grid-five" v-for="(row, rowIndex) in bookRows" :key="rowIndex">
            <div 
              v-for="book in row" 
              :key="book.id"
              class="book-item"
              @click="handleBookClick(book)"
            >
              <div class="book-cover">
                <img 
                  :src="book.cover" 
                  :alt="book.title"
                  @error="handleBookImageError(book)"
                  @load="handleBookImageLoad(book)"
                >
                <div v-if="book.imageError" class="image-placeholder">
                  <i class="el-icon-picture"></i>
                  <span>{{ book.title }}</span>
                </div>
              </div>
              <div class="book-title">{{ book.title }}</div>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination">
            <div 
              class="pagination-prev"
              :class="{ disabled: currentPage === 1 }"
              @click="handlePrevPage"
            >
              上一页
            </div>
            <ul class="pagination-list">
              <li 
                v-for="page in visiblePages" 
                :key="page"
                class="pagination-item"
                :class="{ active: page === currentPage }"
                @click="handlePageClick(page)"
              >
                {{ page === 'ellipsis' ? '...' : page }}
              </li>
            </ul>
            <div 
              class="pagination-next"
              :class="{ disabled: currentPage === totalPages }"
              @click="handleNextPage"
            >
              下一页
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四区域：页脚 -->
    <!-- 网站页脚的component共用模块引入 -->
    <abottom ref="abottom"></abottom>

    <!-- 分类弹出层 -->
    <el-dialog
      :visible.sync="showTagsModal"
      title="更多文献分类"
      width="700px"
      :show-close="false"
      custom-class="custom-modal"
    >
      <div class="modal-tags">
        <div 
          v-for="tag in additionalTags"
          :key="tag"
          class="modal-tag"
          @click="handleModalTagClick(tag)"
        >
          {{ tag }}
        </div>
      </div>
      <div class="modal-description" v-if="showDescription">
        <p><strong>温馨提示：</strong>点击上方任意分类标签，该标签内容将自动填充到搜索框中，您可以直接进行搜索，或进一步细化搜索关键词。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTagsModal = false">关闭</el-button>
      </span>
    </el-dialog>

    <div class="modal-overlay" v-if="showYearsModal" @click="showYearsModal = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2 class="modal-title">更多年份</h2>
          <button class="close-btn" @click="showYearsModal = false">&times;</button>
        </div>
        <div class="year-modal-tags">
          <div 
            v-for="year in moreYears"
            :key="year"
            class="year-modal-tag"
            @click="handleYearModalClick(year)"
          >
            {{ year }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBookRecommand, getBookTwoType} from '../../api/home'
import { developmentUrl } from "../../config/env";

export default {
  name: 'ClassicBookWebsite',
  data() {
    return {
      theClassName:'边疆文献',
      theClassType:'1',
      searchKeyword: '',
      isMobile: false,
      showMobileCategories: false,
      showTagsModal: false,
      showYearsModal: false,
      showDescription: false, // 隐藏温馨提示
      selectedYear: '全部',

      currentPage: 1,  //初始的当前页码
      everyPageNums :20,  //每页上记录数，默认值20
      totalPages: 1,   //初始总页码数
      totalBooks: 0,   //总书籍数量，即总记录数
      booksPerRow: 5,  //分页中的省略号...前面的页码数字

      // displayedYears: ['全部', 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 'more...'],
      // moreYears: [2021, 2022, 2023, 2024, 2025],
      displayedYears: [],
      moreYears: [],
      displayedTypeId:[],
      moreTypeId:[],
      displayedNums:8,   //直接显示在界面上的二级分类数量
      nowTwoClassType:0, //二级书籍类型值为0表示按照一级类型查全部

      additionalTags: [
        '东南亚文献', '南亚文献', '东北亚文献', '中国周边关系文献', 
        '一带一路', '区域国别文献', '各国馆藏文献', '域外古籍',
        '传世医学', '考古古物', '中国农学遗产文献', '商业经济文献', 
        '专题史料文献'
      ],
      books:[],
      theClassLabel: '',
    }
  },
  computed: {
    // 将书籍按行分组（每行5本）
    bookRows() {
      const rows = []
      for (let i = 0; i < this.books.length; i += this.booksPerRow) {
        rows.push(this.books.slice(i, i + this.booksPerRow))
      }
      return rows
    },
    // 计算可见的页码
    visiblePages() {
      const pages = []
      const maxVisible = 5
      
      if (this.totalPages <= maxVisible + 2) {
        // 如果总页数较少，显示所有页码
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i)
        }
      } else {
        // 显示第一页
        pages.push(1)
        
        // 计算起始和结束页码
        let start = Math.max(2, this.currentPage - 1)
        let end = Math.min(this.totalPages - 1, this.currentPage + 1)
        
        // 调整起始和结束页码以确保显示足够的页码
        if (this.currentPage <= 3) {
          start = 2
          end = 4
        } else if (this.currentPage >= this.totalPages - 2) {
          start = this.totalPages - 3
          end = this.totalPages - 1
        }
        
        // 添加省略号
        if (start > 2) {
          pages.push('ellipsis')
        }
        
        // 添加中间页码
        for (let i = start; i <= end; i++) {
          pages.push(i)
        }
        
        // 添加省略号
        if (end < this.totalPages - 1) {
          pages.push('ellipsis')
        }
        
        // 显示最后一页
        pages.push(this.totalPages)
      }
      
      return pages
    }
  },
  mounted() {
    this.theClassName = this.$route.query.classname;
    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth)
    
    // 预加载图片
    this.preloadImages()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)
  },

  //初始化获取网络数据
  created() {
    this.theClassType = this.$route.query.type;
    this.theClassLabel = this.$route.query.label;
    this.GetBookRecommand();
    this.GetBookTwoType();
  },

  methods: {
    //获取各类型的书籍
    GetBookRecommand(){
      this.books = [];
      let queryParams = {};
      queryParams.pageNum = this.currentPage;
      queryParams.pageSize = this.everyPageNums;
      queryParams.onetypeid = this.theClassType;  //书籍一级类型
      if(this.nowTwoClassType != 0){
        queryParams.twotypeid = this.nowTwoClassType;
      }
      queryParams.ispublish = '1';  //发布书籍
      getBookRecommand(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        this.totalBooks = response.data.maprowdata.booknums;

        this.totalPages = Math.ceil(this.totalBooks *1.0 / this.everyPageNums)
        for(let i=0;i<listdata.length;i++){
          let onemap = {};
          onemap.id = listdata[i].id;
          onemap.title = listdata[i].seriesname;
          onemap.booknums = listdata[i].booknums;
          let pictureStr = listdata[i].bookpicture.replace(/^\["/, '').replace(/"\]$/, '');     //去掉数据库中存储的两边的 ["  和 "]
          onemap.cover = developmentUrl + pictureStr.substring(1);
          onemap.imageError = false;
          this.books.push(onemap);
        }
      })
    },

    //获取书籍二级分类服务数据
    GetBookTwoType(){
      let queryParams = {};
      queryParams.oneid = this.theClassType;
      getBookTwoType(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.data;
        this.displayedYears.push('全部');
        this.displayedTypeId.push(0);
        for(let i=0;i<listdata.length;i++){
          if(i<this.displayedNums){
            this.displayedYears.push(listdata[i].typename);
            this.displayedTypeId.push(listdata[i].id);
            if(i==(this.displayedNums-1)){
              this.displayedYears.push('more...');
            }
          }
          else{
            this.moreYears.push(listdata[i].typename);
            this.moreTypeId.push(listdata[i].id);
          }
        }
      })
    },

    checkScreenWidth() {
      this.isMobile = window.innerWidth <= 768
      // 调整移动端每行显示的书籍数量
      if (this.isMobile) {
        this.booksPerRow = window.innerWidth < 576 ? 2 : 3
        // this.booksPerRow = window.innerWidth <= 768 ? 2 : 3     //20260108 not modify
      } else {
        this.booksPerRow = window.innerWidth < 992 ? 4 : 5
      }
    },
    preloadImages() {
      // 预加载所有书籍图片
      this.books.forEach(book => {
        if (book.cover) {
          const img = new Image()
          img.src = book.cover
          img.onload = () => {
            book.imageLoaded = true
          }
          img.onerror = () => {
            book.imageError = true
            console.warn(`图片加载失败: ${book.cover}`)
          }
        }
      })
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        /* this.$message({
          message: `正在搜索: ${this.searchKeyword}`,
          type: 'info'
        }) */
      } else {
        this.$message({
          message: '请输入搜索关键词',
          type: 'warning'
        })
      }
    },
    handleTagClick(tag) {
      this.$message({
        message: `正在按"${tag}"分类进行搜索`,
        type: 'info'
      })
      console.log(`搜索分类: ${tag}`)
    },

    //书籍二级类型的搜索方法处理
    handleYearClick(year) {
      if (year === 'more...') {
        this.showYearsModal = true
        return
      }
      this.selectedYear = year
      console.log(`筛选年份: ${year}`)

      if(year == '全部'){
        this.nowTwoClassType = 0;
      }
      else{
        let theno = this.displayedYears.indexOf(year);
        this.nowTwoClassType = this.displayedTypeId[theno];   //求取界面上当前的二级书籍类型的值
      }
      this.GetBookRecommand();

    },
    handleYearModalClick(year) {
      this.selectedYear = year
      this.showYearsModal = false
      console.log(`选择年份: ${year}`)

      let theno = this.moreYears.indexOf(year);
      this.nowTwoClassType = this.moreTypeId[theno];   //求取界面上当前的二级书籍类型的值
      this.GetBookRecommand();
    },

    handleBookClick(book) {
      // 有分册的书籍的分册数量大于0
      if(book.booknums > 0){
        this.$router.push({
          path: '/singlebook',
          query: { type: book.id, bookname:book.title }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
      else{
        this.$router.push({
          path: '/singlebook',
          query: { type: book.id, bookname:book.title }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
    },

    handleModalTagClick(tag) {
      this.$message({
        message: `正在按"${tag}"分类进行搜索`,
        type: 'info'
      })
      console.log(`从弹出层选择分类搜索: ${tag}`)
      this.showTagsModal = false
    },
    handlePageClick(page) {
      if (page === 'ellipsis') return
      this.currentPage = page
      this.GetBookRecommand();
      console.log(`跳转到第${page}页`)
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.GetBookRecommand();
        console.log('点击上一页')
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        // this.$message({
        //   message: '正在跳转到下一页',
        //   type: 'info'
        // })
        this.GetBookRecommand();
        console.log('点击下一页')
      }
    },
    toggleMobileCategories() {
      this.showMobileCategories = !this.showMobileCategories
      this.$message({
        message: '书籍分类功能（原左侧分类菜单）已整合到搜索分类标签中，请点击搜索标签进行筛选',
        type: 'info'
      })
    },
    handleImageError(e) {
      console.error('Logo图片加载失败')
      e.target.style.display = 'none'
    },
    handleBookImageError(book) {
      console.warn(`书籍图片加载失败: ${book.title}`)
      book.imageError = true
      const imgElement = event.target
      imgElement.style.display = 'none'
    },
    handleBookImageLoad(book) {
      book.imageLoaded = true
      book.imageError = false
    },
    // 返回上级界面
    goBackPage(){
      this.$router.go(-1)
    },

  }
}
</script>

<style scoped>
/* 引入外部字体和图标库 20260105*/
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

/* 基础样式重置与古典风格定义 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Noto Serif SC', serif;
    line-height: 1.6;
    color: #5c3a21;
    background-color: #f5f0e6; /* 古典纸张背景色 */
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
    min-height: 100vh;
    overflow-x: hidden;
}

.container {
    width: 100%;
    /* max-width: 1200px; 20260107，增加界面的宽度*/
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 15px;
}

/* 古典风格边框与阴影 */
.classic-border {
    border: 1px solid #c9b18b;
    border-radius: 3px;
    box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
}

.classic-bg {
    background-color: #fffaf0;
    border: 1px solid #d4c4a8;
}

/* 第一区域：顶部公司信息 */
.header-section {
    background-color: #8b4513; /* 古典深棕色 */
    color: #f5deb3;
    padding: 19px 0;
    border-bottom: 3px solid #d2691e;
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.logo-area {
    display: flex;
    align-items: center;
}

.logo {
    width: 60px;
    height: 60px;
    background-color: #f5deb3;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    border: 2px solid #d2691e;
    overflow: hidden;
}

.logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.site-name h1 {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.8rem;
    color: #f5deb3;
    letter-spacing: 2px;
    text-shadow: 1px 1px 2px #5c3a21;
}

.site-name h1 span{
  font-size: 1.6rem;
}
.english-part {
  display: inline-flex;
  align-items: flex-end; /* 确保MoKu和∞底部对齐 */
}
.moku {
  font-family: 'Noto Serif SC', serif;
  font-weight: 700;
}
.infinity {
  font-size: 1.2em; /* 稍微调整∞的大小 */
  margin-left: 2px; /* 添加一点间距 */
  line-height: 1; /* 防止行高影响对齐 */
}

.site-name p {
    font-size: 0.9rem;
    color: #e6d3b3;
    margin-top: 3px;
    font-family: 'Noto Serif SC', serif;
}

.contact-info {
    text-align: right;
}

/* .contact-info p {
    margin-bottom: 5px;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 5px;
} */
.contact-info p {
  margin-bottom: 5px;
  font-size: 0.95rem;
  text-align: right; /* 确保每个段落都右对齐 */
  font-family: 'Noto Serif SC', serif;
}

/* 第二区域：全站搜索区 */
.search-section {
    padding: 25px 0; /* 减少上下内边距，使搜索框更靠近虚线 */
    background-color: #D7B974; /* 修改为要求的背景色 */
    border-bottom: 2px dashed #8b4513; /* 加深分割虚线颜色 */
    position: relative;
}

.search-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.search-box {
    display: flex;
    width: 100%;
    max-width: 800px;
    margin-bottom: 0; /* 移除底部外边距 */
}

.search-icon {
    background-color: #8b4513;
    color: #f5deb3;
    padding: 15px 20px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-size: 1.2rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-input >>> .el-input__inner {
    padding: 18px;
    border: 1px solid #c9b18b;
    border-left: none;
    border-right: none;
    font-size: 1rem;
    font-family: 'Noto Serif SC', serif;
    background-color: #fffaf0;
    color: #5c3a21;
    min-width: 0; /* 防止flex布局溢出 */
    width: 100%;
    height: 100%;
    border-radius: 0;
}

.search-input >>> .el-input__inner::placeholder {
    color: #8b4513; /* 修改占位符颜色使其更明显 */
}

.search-input >>> .el-input__wrapper {
    padding: 0;
    border: none;
    border-radius: 0;
    background-color: #fffaf0;
    box-shadow: none;
}

.search-button {
    background-color: #a0522d;
    color: #f5deb3;
    border: none;
    padding: 0 25px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    font-family: 'Noto Serif SC', serif;
    font-weight: 600;
    transition: background-color 0.3s;
    flex-shrink: 0;
    height: auto;
}

.search-button:hover {
    background-color: #8b4513;
}

.search-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    max-width: 900px;
}

.search-tag {
    background-color: #fffaf0;
    border: 1px solid #c9b18b;
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 0.9rem;
    color: #5c3a21;
    cursor: pointer;
    transition: all 0.3s;
}

.search-tag:hover {
    background-color: #8b4513;
    color: #f5deb3;
    border-color: #8b4513;
}

.search-tag.more-tag {
    background-color: #e6d3b3;
    border: 1px solid #a0522d;
    color: #8b4513;
    font-weight: 600;
}

/* 第三区域：书籍分类与推荐 */
.main-section {
    padding: 30px 0 40px;
    background-color: #D7B974; /* 修改为要求的背景色 */
}

/* 左侧：移动端书籍分类折叠按钮 */
.mobile-categories-toggle {
    display: none;
    width: 100%;
    background-color: #a0522d;
    color: #f5deb3;
    border: 1px solid #8b4513;
    border-radius: 5px;
    padding: 12px 15px;
    font-family: 'Noto Serif SC', serif;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 15px;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s;
}

.mobile-categories-toggle:hover {
    background-color: #8b4513;
}

.toggle-icon {
    font-size: 1.2rem;
    transition: transform 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toggle-icon.expanded {
    transform: rotate(90deg);
}

/* 期刊分类标题区域 */
.category-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fffaf0;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #c9b18b;
    box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
    margin-bottom: 25px;
}

.category-header-left {
    display: flex;
    align-items: center;
}

.category-title {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.8rem;
    color: #8b4513;
    letter-spacing: 2px;
}

.category-count {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.2rem;
    color: #a0522d;
    font-weight: 600;
    background-color: #f9f5eb;
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #c9b18b;
}

/* 年份标签区 */
.year-tags-section {
    background-color: #fffaf0;
    padding: 15px 20px; /* 减少上下内边距 */
    border-radius: 5px;
    border: 1px solid #c9b18b;
    box-shadow: 0 4px 8px rgba(92, 58, 33, 0.08);
    margin-bottom: 25px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: space-between; /* 水平两端对齐 */
    flex-wrap: wrap; /* 允许换行 */
}

.year-tags-title {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.2rem;
    color: #8b4513;
    font-weight: 600;
    display: flex;
    align-items: center;
    white-space: nowrap; /* 防止标题换行 */
    margin-right: 20px; /* 与年份标签之间的间距 */
}

.year-tags-title i {
    margin-right: 10px;
    font-size: 1.3rem;
}

.year-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center; /* 垂直居中 */
}

.year-tag {
    background-color: #f9f5eb;
    border: 1px solid #c9b18b;
    padding: 8px 18px; /* 调整内边距 */
    border-radius: 25px;
    font-size: 1rem;
    color: #5c3a21;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap; /* 防止年份文字换行 */
    font-family: 'Noto Serif SC', serif;
}

.year-tag:hover {
    background-color: #a0522d;
    color: #f5deb3;
    border-color: #a0522d;
    transform: translateY(-2px);
}

.year-tag.active {
    background-color: #8b4513;
    color: #f5deb3;
    border-color: #8b4513;
    font-weight: 600;
}

.year-tag.more-tag {
    background-color: #e6d3b3;
    border: 1px solid #a0522d;
    color: #8b4513;
    font-weight: 600;
}

.year-tag.more-tag:hover {
    background-color: #a0522d;
    color: #f5deb3;
}

/* 书籍网格 - 每行5本书 */
.books-container {
    background-color: #fffaf0;
    padding: 30px;
    border-radius: 5px;
    border: 1px solid #c9b18b;
    box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

.books-grid-five {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 25px;
    margin-bottom: 30px;
}

.book-item {
    text-align: center;
    transition: transform 0.3s;
}

.book-item:hover {
    transform: translateY(-5px);
}

.book-cover {
    width: 100%;
    /* 高度设置为宽度的1.4倍 */
    height: 0;
    padding-bottom: 140%; /* 1.4 * 100% */
    position: relative;
    background-color: #e6d3b3;
    margin-bottom: 12px;
    border-radius: 3px;
    overflow: hidden;
    border: 1px solid #c9b18b;
    box-shadow: 0 3px 6px rgba(92, 58, 33, 0.1);
}

.book-cover img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
}

/* 图片占位符 */
.image-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #8b4513 0%, #a0522d 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #f5deb3;
    padding: 10px;
}

.image-placeholder i {
    font-size: 2rem;
    margin-bottom: 10px;
    opacity: 0.8;
}

.image-placeholder span {
    font-size: 0.9rem;
    text-align: center;
    line-height: 1.2;
}

.book-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #5c3a21;
    margin-bottom: 5px;
    line-height: 1.4;
    min-height: 2.8em;
    display: flex;
    align-items: flex-start; /* 修改为顶部对齐 */
    justify-content: center;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
    width: 100%; /* 确保宽度与图片相同 */
    font-family: 'Noto Serif SC', serif;
}

/* 分页样式 */
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #d4c4a8;

    font-family: 'Noto Serif SC', serif;
}

.pagination-list {
    display: flex;
    list-style: none;
    gap: 8px;
}

.pagination-item {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f5eb;
    border: 1px solid #c9b18b;
    border-radius: 3px;
    color: #5c3a21;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s;
}

.pagination-item:hover {
    background-color: #f0e6d2;
    border-color: #a0522d;
}

.pagination-item.active {
    background-color: #8b4513;
    color: #f5deb3;
    border-color: #8b4513;
    font-weight: 700;
}

.pagination-prev,
.pagination-next {
    width: 80px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f5eb;
    border: 1px solid #c9b18b;
    border-radius: 3px;
    color: #5c3a21;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s;
    margin: 0 10px;
}

.pagination-prev:hover,
.pagination-next:hover {
    background-color: #f0e6d2;
    border-color: #a0522d;
}

.pagination-prev.disabled,
.pagination-next.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* 第四区域：页脚 */
.footer-section {
    background-color: #5c3a21;
    color: #e6d3b3;
    padding: 25px 0;
    border-top: 3px solid #8b4513;
}

.footer-info {
    text-align: center;
    line-height: 1.8;
}

.footer-info p {
    margin-bottom: 8px;
    font-size: 0.95rem;
    font-family: 'Noto Serif SC', serif;
}

/* 对话框自定义样式 */
.custom-modal >>> .el-dialog {
    background-color: #fffaf0;
    border-radius: 8px;
    border: 2px solid #c9b18b;
}

.custom-modal >>> .el-dialog__header {
    border-bottom: 2px solid #d4c4a8;
    padding-bottom: 15px;
    margin-bottom: 20px;
}

.custom-modal >>> .el-dialog__title {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.8rem;
    color: #8b4513;
    letter-spacing: 1px;
}

.custom-modal >>> .el-dialog__body {
    padding: 0 30px 20px;
}

.custom-modal >>> .el-dialog__footer {
    border-top: 1px solid #d4c4a8;
    padding-top: 20px;
}

.modal-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 25px;
}

.modal-tag {
    background-color: #f9f5eb;
    border: 1px solid #c9b18b;
    padding: 12px 20px;
    border-radius: 25px;
    font-size: 1rem;
    color: #5c3a21;
    cursor: pointer;
    transition: all 0.3s;
    flex: 1;
    min-width: 200px;
    text-align: center;
}

.modal-tag:hover {
    background-color: #8b4513;
    color: #f5deb3;
    border-color: #8b4513;
    transform: translateY(-2px);
}

.modal-description {
    font-size: 1rem;
    line-height: 1.7;
    color: #5c3a21;
    background-color: #f9f5eb;
    padding: 20px;
    border-radius: 5px;
    border: 1px dashed #c9b18b;
    display: none; /* 隐藏温馨提示内容区 */
}

/* 年份弹出层样式 */
.year-modal-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 25px;
}

.year-modal-tag {
    background-color: #f9f5eb;
    border: 1px solid #c9b18b;
    padding: 12px 25px;
    border-radius: 25px;
    font-size: 1.1rem;
    color: #5c3a21;
    cursor: pointer;
    transition: all 0.3s;
    flex: 1;
    min-width: 180px;
    text-align: center;
}

.year-modal-tag:hover {
    background-color: #a0522d;
    color: #f5deb3;
    border-color: #a0522d;
    transform: translateY(-2px);
}

/* 弹出层样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fffaf0;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  overflow-y: auto;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 2px solid #c9b18b;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #d4c4a8;
}

.modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  letter-spacing: 1px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #8b4513;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: rgba(139, 69, 19, 0.1);
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .books-grid-five {
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
    }
}

@media (max-width: 992px) {
    .books-grid-five {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }
    
    .custom-modal >>> .el-dialog {
        width: 95%;
    }
    
    .modal-tag {
        min-width: 150px;
    }
    
    .year-modal-tag {
        min-width: 150px;
        padding: 10px 20px;
    }
    
    .category-count {
        font-size: 1.1rem;
        padding: 7px 14px;
    }
    
    /* 年份标签区响应式调整 */
    .year-tags-section {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .year-tags-title {
        margin-right: 0;
        margin-bottom: 15px;
    }
    
    .year-tags {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .header-container {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .contact-info {
        text-align: left;
        margin-top: 15px;
    }
    
    .site-name h1 {
        font-size: 1.5rem;
    }
    
    /* 搜索框不换行 */
    .search-box {
        flex-direction: row;
        overflow: hidden;
    }
    
    .search-icon, .search-input, .search-button {
        border-radius: 0;
        border: 1px solid #c9b18b;
        margin: 0;
        width: auto;
        flex-shrink: 0;
    }
    
    .search-icon {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        text-align: center;
        padding: 15px;
        width: 50px;
    }
    
    .search-input >>> .el-input__inner {
        flex: 1;
        min-width: 0;
        border-left: none;
        border-right: none;
        padding: 15px 10px;
    }
    
    .search-button {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        padding: 15px 20px;
        white-space: nowrap;
    }
    
    /* 隐藏搜索标签 */
    .search-tags {
        display: none;
    }
    
    /* 移动端每行显示3本书 */
    .books-grid-five {
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
    }
    
    .custom-modal >>> .el-dialog {
        width: 98%;
    }
    
    .modal-tags {
        gap: 10px;
    }
    
    .modal-tag {
        min-width: 120px;
        padding: 10px 15px;
        font-size: 0.9rem;
    }
    
    .year-modal-tag {
        min-width: 120px;
        padding: 10px 15px;
        font-size: 0.9rem;
    }
    
    .modal-title {
        font-size: 1.5rem;
    }
    
    /* 20260108,修改字体 */
    .category-title {
        font-size: 1.0rem;
    }
    
    .category-count {
        font-size: 1rem;
        padding: 6px 12px;
    }
    
    /* 年份标签区响应式 */
    .year-tags {
        gap: 8px;
    }
    
    .year-tag {
        padding: 8px 15px;
        font-size: 0.9rem;
    }
    
    .year-tags-title {
        font-size: 1.1rem;
    }
    
    /* 移动端书籍分类样式 */
    .mobile-categories-toggle {
        display: flex;
    }
    
    /* 分页响应式 */
    .pagination-list {
        gap: 5px;
    }
    
    .pagination-item {
        width: 35px;
        height: 35px;
        font-size: 0.85rem;
    }
    
    .pagination-prev,
    .pagination-next {
        /* width: 70px; */
        width: 50px;
        height: 35px;
        font-size: 0.85rem;
        /* margin: 0 5px; 20260108*/
        margin: 0 0px;
    }
}

@media (max-width: 576px) {
    .site-name h1 {
        font-size: 1.3rem;
    }
    
    .logo {
        width: 50px;
        height: 50px;
    }
    
    .contact-info p {
        font-size: 0.85rem;
    }
    
    /* 小屏幕每行显示2本书 */
    .books-grid-five {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    
    /* 20260108,修改字体 */
    .category-title {
        font-size: 1.0rem;
    }
    
    .category-count {
        font-size: 0.9rem;
        padding: 5px 10px;
    }
    
    .footer-info p {
        font-size: 0.85rem;
    }
    
    .modal-tag {
        min-width: 100%;
    }
    
    .year-modal-tag {
        min-width: 100%;
    }
    
    /* 手机上进一步优化搜索框 */
    .search-icon {
        width: 45px;
        padding: 12px;
    }
    
    .search-button {
        padding: 12px 15px;
        font-size: 0.9rem;
    }
    
    .search-input >>> .el-input__inner {
        padding: 12px 8px;
        font-size: 0.9rem;
    }
    
    /* 书籍容器内边距 */
    .books-container {
        padding: 20px;
    }
    
    /* 移动端分类标题布局调整为垂直 */
    .category-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .category-header-left {
        width: 100%;
    }
    
    .category-count {
        align-self: flex-end;
        margin-top: -10px;
    }
    
    /* 年份标签区调整 */
    .year-tags-section {
        padding: 15px;
    }
    
    .year-tags {
        gap: 6px;
    }
    
    .year-tag {
        padding: 6px 12px;
        font-size: 0.85rem;
    }
    
    /* 分页进一步调整 */
    .pagination-list {
        flex-wrap: wrap;
        justify-content: center;
    }
}

@media (max-width: 400px) {
    /* 超小屏幕每行显示2本书 */
    .books-grid-five {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }
    
    .book-title {
        font-size: 0.85rem;
    }
    
    /* 超小屏幕搜索框优化 */
    .search-icon {
        width: 40px;
        padding: 10px;
        font-size: 1rem;
    }
    
    .search-button {
        padding: 10px 12px;
        font-size: 0.85rem;
    }
    
    .search-input >>> .el-input__inner {
        padding: 10px 6px;
        font-size: 0.85rem;
    }
    
    /* 年份标签区调整 */
    .year-tags {
        gap: 5px;
    }
    
    .year-tag {
        padding: 5px 10px;
        font-size: 0.8rem;
    }
    
    /* 分页简化 */
    .pagination-list {
        gap: 3px;
    }
    
    .pagination-item {
        width: 30px;
        height: 30px;
        font-size: 0.8rem;
    }
    
    .pagination-prev,
    .pagination-next {
        /* width: 60px; */
        width: 50px;
        height: 30px;
        font-size: 0.8rem;
        /* margin: 0 3px; 20260108*/
        margin: 0 0px;
    }
}

/* 古典印章样式 */
.seal-style {
    display: inline-block;
    padding: 5px 10px;
    background-color: #8b4513;
    color: #f5deb3;
    border-radius: 3px;
    font-size: 0.8rem;
    font-family: 'Noto Serif SC', serif;
    letter-spacing: 1px;
}
</style>


// WEBPACK FOOTER //
// src/views/classpage/index.vue